import { createStore, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import reducer from "./reducers/index";
import { loadState, saveState } from "./utils/localStorage";

const initialState = loadState() || {
  page: 0,
  rowsPerPage: 10,
  drawer: false,
  expanded: true,
  selected: "panel1",
  loading: false, // Added loading to initial state
};

let composeEnhacers;
if (process.env.NODE_ENV === "production") {
  composeEnhacers = compose;
} else {
  composeEnhacers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}

const store = createStore(
  reducer,
  initialState,
  composeEnhacers(applyMiddleware(thunk))
);

store.subscribe(() => {
  saveState(store.getState());
});

export default store;
